<!-- Main Page and Parent component for all pages 
 Copy right - © 2024 tecera gmbh
 -->
<script>
    import { Router, Route } from "svelte-routing";
    import Hydranten from "./pages/Hydranten.svelte";
    import Login from "./pages/Login.svelte";
    import Register from "./pages/Register.svelte";
    import Reset from "./pages/Reset.svelte";
    import WasserZaehler from "./pages/WasserZaehler.svelte";
    import MontageUebersicht from "./pages/MontageUebersicht.svelte";
    import Verwaltung from "./pages/Verwaltung.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import DevPage from "./pages/DevPage.svelte";
    import Toast from "./components/Toast.svelte";
    import {DEBUG} from "./config.js";
    import TrinkwasserNetzdaten from "./pages/TrinkwasserNetzdaten.svelte";
    import DeviceVerwaltung from "./pages/DeviceVerwaltung.svelte";
</script>

<Toast />

<Router>
    <Route path="/" component={Login} />
    <Route path="/hydranten" component={Hydranten} />
    <Route path="/montage_uebersicht" component={MontageUebersicht} />
    <Route path="/register" component={Register} />
    <Route path="/reset_password" component={Reset} />
    <Route path="/wasserzaehler" component={WasserZaehler} />
    <Route path="/trinkwasser" component={TrinkwasserNetzdaten} />
    <Route path="/user_management" component={Verwaltung} />
    <Route path="/device_management" component={DeviceVerwaltung} />

    {#if DEBUG}
    <Route path="/dev" component={DevPage} />
    {/if}
    <Route path="/*" component={NotFound} />
</Router>
